export default __webpack_public_path__ + "static/media/hamburger.f50059d2.svg";